import React, { FC, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { ModifiedEntityTable } from './ModifiedEntityTable';
import { Checked } from '../common/Checked';
import { IEntityVersionDiffVm } from '@yakoffice/publisher-types';
import { useMultiSelect } from '../../components/use-multi-select/useMultiSelect';
import { ButtonGroup } from 'react-bootstrap';


interface PropTypes {
    className?: string
    title?: string
    modifiedEntities: IEntityVersionDiffVm[],
    allowSelection: boolean,
    handleMergeChanges?: (entityVersionDiffs: IEntityVersionDiffVm[]) => void
}

export const GroupedByKindModifiedEntityVersionsContent: FC<PropTypes> = ({
                                                                              className,
                                                                              title,
                                                                              modifiedEntities,
                                                                              allowSelection,
                                                                              handleMergeChanges
                                                                          }) => {
    const [checkAll, setCheckAll] = useState(false);
    const [checkedEntities, setCheckedEntities] = useState<Checked<IEntityVersionDiffVm>[]>(modifiedEntities.map(e => ({
        checked: checkAll,
        value: e
    })));
    const multiSelect = useMultiSelect<Checked<IEntityVersionDiffVm>>({
        items: checkedEntities,
        selectItem: (item, selected) => {
            if (item.value.modifiedProperties.length === 0)
                return;

            item.checked = selected;
            setCheckedEntities(prevState => prevState.map(p => p));
        }
    });

    useEffect(() => {
            setCheckAll(false);
            setCheckedEntities(modifiedEntities.map(e => ({ checked: false, value: e })));
        }
        , [modifiedEntities]);

    const handleCheckedChange = (checkedEntity: Checked<IEntityVersionDiffVm>, checked: boolean) => {
        multiSelect.handleItemSelection(checkedEntity, checked);
    };

    const handleCheckAll = () => {
        const newState = !checkAll;
        multiSelect.handleSelectAll(newState);
        setCheckAll(newState);
    };

    return (
        <div>
            <ButtonGroup className={`justify-content-end mb-2`}>
                {allowSelection && modifiedEntities.map((me) => me.modifiedProperties).flat().length > 0 && checkedEntities.length > 0 && (
                    <>
                        <Button
                            className="btn btn-primary"
                            onClick={() => handleMergeChanges && handleMergeChanges(checkedEntities.filter((c) => c.checked).map((c) => c.value))}
                            disabled={!checkedEntities.find((ce) => ce.checked)}
                            data-testid="btnMergeEntities"
                        >Merge modified</Button>

                        <Button className="btn btn-primary" onClick={() => handleCheckAll()}>
                            {checkAll ? 'Unselect All' : 'Select All'}
                        </Button>
                    </>
                )}
            </ButtonGroup>
            {checkedEntities.map((checkedEntity) => (
                <ModifiedEntityTable
                    key={checkedEntity.value.diffEntityId}
                    className={className}
                    entityVersionDiff={checkedEntity.value}
                    displayCheckbox={allowSelection && checkedEntity.value.modifiedProperties.length > 0}
                    checked={checkedEntity.checked}
                    handleCheckedChange={(checked: boolean) => handleCheckedChange(checkedEntity, checked)}
                />
            ))}
        </div>
    );
};
